module.exports = __webpack_public_path__ + "31df699df869617d607ca9c3276cebcd.png";